import React from "react";
import { Button, Modal } from "../../components";
import { Box, Typography } from "@mui/material";

interface IProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
}

const ConfirmationModal: React.FC<IProps> = ({
    open,
    onClose,
    loading = false,
    onConfirm,
    title,
    message,
    confirmText = "Yes",
    cancelText = "No",
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title ?? "Confirmation"}
            showClose={true}
            loading={loading}
        >
            <Box>
                <Box sx={{ py: 4 }}>
                    <Typography style={{ textAlign: "center" }}>
                        {message}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                    <Button
                        disabled={loading}
                        fullWidth
                        variant="outlined"
                        onClick={onClose}
                    >
                        {cancelText}
                    </Button>
                    <Button loading={loading} fullWidth variant="contained" onClick={onConfirm}>
                        {confirmText}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;
